import {CheckCircleFillIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {mergeabilityStatus, Status} from '@github-ui/mergebox/helpers/mergeability-status'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useScrollToMergeBox} from '../../mergebox/use-scroll-to-mergebox'
import {useMergeabilityData} from './use-mergeability-data'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'

// Renders for the author/assignees when the pull request is mergeable ("Ready to merge"),
// offering a shortcut that scrolls to the merge box so they can complete the merge.
export function ReadyToMerge() {
  const data = useMergeabilityData()
  const scrollToMergeBox = useScrollToMergeBox()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  if (!data) {
    return null
  }

  const {mergeBoxPullRequest, mergeRequirements, statusChecksData} = data
  const status = mergeabilityStatus({
    pullRequest: mergeBoxPullRequest,
    mergeRequirements,
    statusChecksData,
  })

  if (status !== Status.Mergeable) {
    return null
  }

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={CheckCircleFillIcon} variant="success" />}
      title="Ready to merge"
      itemName="ready-to-merge"
      actionSlot={
        <Button
          size="small"
          onClick={() => {
            sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
              item_name: 'ready-to-merge',
              action_name: 'go_to_merge_box',
            })
            scrollToMergeBox()
          }}
        >
          Go to merge box
        </Button>
      }
    />
  )
}
